import { inject, Injectable } from '@angular/core';
import { SessionService } from '@common/services/session.service';
import { Observable, tap, map, catchError, of } from 'rxjs';
import { IAuthCommand, IAuthResponse } from '../interfaces/auth.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.dev';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly sessionService: SessionService = inject(SessionService);
  private readonly http: HttpClient = inject(HttpClient);


  login(command: IAuthCommand): Observable<boolean> {

    return this.http.post<IAuthResponse>(`${environment.services.api}/auth/login`, command)
    .pipe(
      tap((resp: IAuthResponse) => {
        this.sessionService.create(resp.jwt);
      }),
      map((resp: IAuthResponse) => true)
    )
  }

  logout() {
    this.sessionService.close();
  }

}
